module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.10@core-js/library/modules/_library.js
// module id = 27
// module chunks = 0